export enum EventOrigin {
  HomeFeed = "home-feed",
  BrandPage = "brand-page",
  OrdersPage = "orders-page",
  MyBrandsPage = "my-brands-page",
  MyBrandsUpdatesPage = "my-brands-updates-page",
  Unknown = "unknown",
}

export enum InsightCardElement {
  Brand = "brand",
  Product = "product",
  Overlay = "overlay",
}

export enum MuteAction {
  Mute = "mute",
  Unmute = "unmute",
  Dismiss = "dismiss",
}

export const OVERLAY_EVENT_TOKEN = "overlay";
